<template>
	<div class="affairs-list">
		<AffairListItem
			v-for="item in grouped_tasks"
			:data="item"
			:key="item.id"
			@assignToManager="onAssignToManager"
			@editTask="onEditTask"
		/>
	</div>
</template>

<script>
import AffairListItem from '@/components/affairs/AffairListItem'

import moment from 'moment'
import {groupBy, get, flatMap, orderBy} from 'lodash'

export default {
	name: 'AffairsList',
	components: {
		AffairListItem,
	},
	props: {
		taskList: {
			type: Array,
			default: () => []
		},
		filter:{
			type: Boolean,
			default: false,
		}
	},
	data () {
		return {
			// activePromptAssignToManager: false,
			// taskToAssign: null,
			// assignedManager: null
		}
	},
	computed: {
		taskListFormated(){
			let arr = this.taskList.filter(e => this.filter ? !e.is_completed : true);
			return arr.filter(e => this.filter ? !e.isNotRelevant : true)
		},
		grouped_tasks () {
			let list = this.taskListFormated.sort((a, b) => new Date(a.date_time) - new Date(b.date_time))
			let groups = groupBy(
				list,
				(o) => moment(get(o, 'date_time', '')).format('YYYY-MM-DD')
			)
			return flatMap(groups, (v, k) => [{date: k}, ...v])
		}
	},
	methods: {
		onAssignToManager (e) {
			this.$emit('assignToManager', e)
			// this.taskToAssign = e
			// this.activePromptAssignToManager = true
		},
		// assignToManager () {
		//   this.$store.dispatch('calendar/assignTaskToManager', {
		//     task: this.taskToAssign,
		//     manager: {manager_id: this.assignedManager}
		//   })
		// },
		onEditTask (e) {
			this.$emit('editTask', e)
		},
	},
}
</script>

<style scoped lang="scss">
.affairs-list {
	width: 100%;

}
</style>
